import { Injectable } from '@angular/core';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';
import {
  loadNextListProducts,
  QUERY_UPDATE_STRATEGY,
  resetListProducts,
  setSearchSortTypeInListEntity,
  SORT_TYPE_PRODUCTS_UPDATE_STRATEGY,
} from '@epicuro-next/state/list-entities';
import { selectProductBasketQueryParams } from '@epicuro-next/state/p-basket-state';
import { go } from '@epicuro-next/state/router-store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { concatMap, filter, map } from 'rxjs/operators';

import { setActiveList } from '../../actions/list/active-list.actions';
import { addProductsManually } from '../../actions/list/products.actions';

@Injectable()
export class ProductsEffects {
  constructor(private actions$: Actions, private store: Store) {}

  public makeListActive$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addProductsManually),
      map(({ listId }) => {
        return setActiveList({ id: listId });
      }),
    ),
  );

  public redirectToSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addProductsManually),
      concatLatestFrom(() => [
        this.store.pipe(select(selectProductBasketQueryParams)),
      ]),
      map(([, queryParams]) => {
        return go({
          commands: [
            '/',
            APP_PRIVATE_PATHS.browse.path,
            APP_PRIVATE_PATHS.search.path,
          ],
          extras: {
            queryParams,
          },
        });
      }),
    ),
  );

  public groupingOptionChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSearchSortTypeInListEntity),
      filter(
        ({ strategy }) =>
          strategy === SORT_TYPE_PRODUCTS_UPDATE_STRATEGY.ENTITY,
      ),
      concatMap(({ listId }) => [
        resetListProducts({ listId }),
        loadNextListProducts({
          listId,
          strategy: QUERY_UPDATE_STRATEGY.OVERWRITE,
        }),
      ]),
    ),
  );
}
